import { DISPLAY_FEEDBACK, HIDE_FEEDBACK, HIDE_FEEDBACK_FOREVER } from '../actions/types'

interface FeedBackFormStore {
    displayFeedBack: boolean
    relatedConsultId: any
}

const INITIAL_STATE: FeedBackFormStore = {
    displayFeedBack: false,
    relatedConsultId: null,
}

export default (state = INITIAL_STATE, action: any): FeedBackFormStore => {
    switch (action.type) {
        case DISPLAY_FEEDBACK:
            return {
                ...state,
                displayFeedBack: true,
                relatedConsultId: action.payload.consultId,
            }
        case HIDE_FEEDBACK:
            return {
                ...state,
                displayFeedBack: false,
            }
        case HIDE_FEEDBACK_FOREVER:
            return {
                ...state,
                displayFeedBack: false,
            }
        default:
            return state
    }
}
